module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADeSURBVHgB7ZRBCsIwEEUno+57ASE30d7AI1Sq0p31Nl24yBU8Qa/gEbJx33VDMyZgUarQSUUU7IfCMJl5j5JSgDE9Ed3GcS5XQJM9DIil5rC76PNjD7tDRFCBsDDkQQsSfjpJnkdJlsmQHcEd9GA0tvS1nWGsikJz9liCO5zkbU1zJb2CFk7u9oUQ7iOgyrUjX3MkyIWTNbHDaxBU+dr3/FnfnSAXrpTS7ZmvuRIMhYdKcAg8RPL8BnW95MBfSYQxC3gnabot1+mmDNlB+HBGwfcF05DhhujkfkgEf5UrDlrD42rzP/sAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qd3.png
// module id = lvvB
// module chunks = 1